import { Typography } from '@mui/material';
import { useMemo } from 'react';
import useAppStore from 'store/useAppStore';
import { svgConfig } from './utils';
import RenderNodes from './RenderNodes';
import RenderArrows from './RenderArrows';
import keyBy from 'lodash/keyBy';
const Chart = ({ handleScriptClick }) => {
  const materialDevices = useAppStore((state) => state.materialDevices);
  const stations = useAppStore((state) => state.stations);
  const scripts = useAppStore((state) => state.scripts);
  const svgWidth = useMemo(() => {
    const maxLength = Math.max(
      scripts.length,
      materialDevices.length,
      stations.length,
    );
    return (maxLength + 0.5) * 160;
  }, [materialDevices.length, scripts.length, stations.length]);

  const sortDevices = useMemo(() => {
    const copyDevices = [...materialDevices];
    const array = [];
    scripts.forEach((script) => {
      const findIndex = copyDevices.findIndex(
        (d) => d.id === script['移動設備'].id,
      );
      if (findIndex !== -1) {
        array.push(copyDevices[findIndex]);
        copyDevices.splice(findIndex, 1);
      }
    });
    return [...array, ...copyDevices];
  }, [materialDevices, scripts]);
  const sortStations = useMemo(() => {
    const copyStations = [...stations];
    const array = [];
    scripts.forEach((script) => {
      const findIndex = copyStations.findIndex(
        (d) => d.id === script['起始工站'].id,
      );
      if (findIndex !== -1) {
        const keyById = keyBy(stations, 'id');
        array.push(keyById[script['起始工站'].id]);
        copyStations.splice(findIndex, 1);
      }
    });
    return [...array, ...copyStations];
  }, [scripts, stations]);
  return (
    <>
      {materialDevices.length > 0 ||
      stations.length > 0 ||
      scripts.length > 0 ? (
        <svg
          width={svgWidth}
          height={svgConfig.height}
          viewBox={`0 0 ${svgWidth} ${svgConfig.height}`}
        >
          {/* 第一行：物料移動設備 */}
          <RenderNodes color="#4CAF50" items={sortDevices} rowIndex={0} />

          {/* 第二行：站台 */}
          <RenderNodes color="#2196F3" items={sortStations} rowIndex={1} />

          {/* 第三行：腳本 */}
          <RenderNodes
            handleScriptClick={handleScriptClick}
            color="#FF9800"
            items={scripts}
            rowIndex={2}
          />

          {/* 連接箭頭 */}
          <RenderArrows sortDevices={sortDevices} sortStations={sortStations} />
        </svg>
      ) : (
        <Typography variant="body2" color="text.secondary">
          請先添加物料設備、站台和腳本以顯示流程圖
        </Typography>
      )}
    </>
  );
};
export default Chart;
